
const state = {
  alerts: [],
}

const mutations = {
  ADD_ALERT (state, alert) {
    state.alerts.push(alert)
  },
  REMOVE_ALERT (state, index) {
    state.alerts.splice(index, 1)
  },
  CLEAR_ALERTS (state) {
    state.alerts = []
  },
}

const actions = {
  addAlert (
    context,
    {
      border = 'left',
      color = '',
      message = '',
      type = 'success',
      timeout = 7000,
    } = {},
  ) {
    context.commit('ADD_ALERT', {
      border,
      color: color || type,
      message,
      type,
      transition: 'slide-x-reverse-transition',
    })

    setTimeout(() => {
      context.commit('REMOVE_ALERT', 0)
    }, timeout)
  },

  addErrorAlert (context, message = '') {
    context.dispatch('addAlert', {
      type: 'error',
      message,
    })
  },

  addSuccessAlert (context, message = '') {
    context.dispatch('addAlert', {
      type: 'success',
      message,
    })
  },

  addWarningAlert (context, message = '') {
    context.dispatch('addAlert', {
      type: 'warning',
      message,
    })
  },
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
